import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { NcdclientService } from 'src/app/services/NCD/ncdclient.service';

@Component({
  selector: 'app-document-generation-master-setup',
  templateUrl: './document-generation-master-setup.component.html',
  styleUrls: ['./document-generation-master-setup.component.css']
})
export class DocumentGenerationMasterSetupComponent implements OnInit {

  documents: any;
  editDocument: any;
  @Input() issueId: any;

  @ViewChild(DataTableDirective)
  // @Input() meetingTypeId;
  dtElement: DataTableDirective;
  dtDocumentList: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(private ncdService: NcdclientService, private router: Router,private route: ActivatedRoute) { }

  ngOnInit() {

    this.dtDocumentList = {
      processing: false,
      serverSide: true,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      // pagingType: 'full_numbers',
      // paging: true,
      // pageLength: 10,
      autoWidth: false,
      // search: true,
      // order: [0, 'asc'],
      // lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [0,1,2,3] }],
      dom: 'Brt',//'Bfrtip',
      buttons: []
    };

    this.getDocuments();
    window.alert = function() {};

    var element = document.getElementById("srno");
    element.classList.remove("sorting_asc");
  }

  getDocuments() {
    this.documents = [];
    $("#ncdDocGenMaster").DataTable().destroy();
    this.ncdService.getDocumentGenrationMasterSetup().subscribe(resData => {
      console.log(resData)
      this.documents = resData;
      console.log(this.documents)

      this.dtTrigger.next();
    }, error => {
    })
  }

  onEditDocument(srNo, id) {
    this.editDocument = this.issueId;
    this.ncdService.setDocument({ id: id, srNo: srNo, issueId: this.issueId });
  }

  editDocumentMaster(documentid){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['ncd','document','generation','mster','setup',documentid]  } }],
      { relativeTo: this.route.parent });
  }
}

